@if (isFetching) {
  <div class="f-row f-v-center {{wrapperClass}}">
    <div class="national-attributes--temperature">&nbsp;<ngx-skeleton-loader [theme]="{
        height: '33px',
        width:  '30px',
        margin: '0 5px',
        position: 'relative',
        top: '-10px'
      }"></ngx-skeleton-loader>
      <div class="absolute">
        <a [class.active]="!isFahrenheit" (click)="isFahrenheit = false; preventDefault($event)">C</a>
        |
        <a  [class.active]="isFahrenheit" (click)="isFahrenheit = true; preventDefault($event)">F</a>
      </div>
    </div>
    <div>
      <div class="national-attributes--weather">Precipitation: <ngx-skeleton-loader [theme]="{
        height: '14px',
        width:  '20px',
        margin: '0 5px',
        position: 'relative',
        top: '3px'
      }"></ngx-skeleton-loader>mm
      </div>
      <div class="national-attributes--weather">Humidity: <ngx-skeleton-loader [theme]="{
        height: '14px',
        width:  '20px',
        margin: '0 5px',
        position: 'relative',
        top: '3px'
      }"></ngx-skeleton-loader>%</div>
      <div class="national-attributes--weather">Wind: <ngx-skeleton-loader [theme]="{
        height: '14px',
        width:  '20px',
        margin: '0 5px',
        position: 'relative',
        top: '3px'
      }"></ngx-skeleton-loader>km/h</div>
    </div>
  </div>
} @else {
  <div class="f-row f-v-center {{wrapperClass}}">
    <div class="national-attributes--temperature"><span>{{ roundTemperature(isFahrenheit ? weather?.temp_f : weather?.temp_c) }}</span>
      <div class="absolute">
        <a [class.active]="!isFahrenheit" (click)="isFahrenheit = false">C</a>
        |
        <a  [class.active]="isFahrenheit" (click)="isFahrenheit = true">F</a>
      </div>
    </div>
    <div>
      <div class="national-attributes--weather">Precipitation: {{ weather?.precip_mm }}mm
      </div>
      <div class="national-attributes--weather">Humidity: {{ weather?.humidity }}%</div>
      <div class="national-attributes--weather">Wind: {{ weather?.wind_kph }}km/h</div>
    </div>
  </div>
}
